import { useSearchParams } from 'react-router-dom'
import qs from 'qs'
import dayjs from 'dayjs'
import { RangeValue } from 'types/shared'

const QUERY_ARRAY_LIMIT = 100
export type AllFiltersGeneric = Record<string, unknown> & {
  rangePicker?: RangeValue<dayjs.Dayjs>
}

const useFilterParamsGeneric = (initialFiltersValue: AllFiltersGeneric) => {
  const initialString = transformAllFiltersToString(initialFiltersValue)

  const [params, setParams] = useSearchParams(initialString)

  const filterParamsGeneric = transformStringToAllFilters(params.toString())

  const setFilterParams = (
    getState: (prevState: AllFiltersGeneric) => AllFiltersGeneric
  ) => {
    const newState = getState(filterParamsGeneric)
    const newQueryParams = transformAllFiltersToString(newState)

    setParams(newQueryParams)
  }

  const queryParams = transformAllFiltersToString(initialFiltersValue)

  return { filterParamsGeneric, setFilterParams, queryParams } as const
}

const transformAllFiltersToString = (params: AllFiltersGeneric): string => {
  const rangePicker = params?.rangePicker?.map((date) =>
    date?.toISOString?.()
  ) as AllFiltersGeneric['rangePicker']

  const newQueryString = qs.stringify({
    ...params,
    rangePicker,
  })

  return newQueryString
}

export const transformStringToAllFilters = (
  queryParams: string
): AllFiltersGeneric => {
  const newFilterParams =
    (qs.parse(queryParams, { arrayLimit: QUERY_ARRAY_LIMIT }) as Omit<
      AllFiltersGeneric,
      'rangePicker'
    > & {
      rangePicker: [string | null, string | null] | undefined | null
    }) || {}

  if (newFilterParams?.rangePicker) {
    ;(newFilterParams.rangePicker as AllFiltersGeneric['rangePicker']) =
      newFilterParams.rangePicker?.map((dateString) =>
        dayjs(dateString)
      ) as AllFiltersGeneric['rangePicker']
  }

  return newFilterParams as AllFiltersGeneric
}

export default useFilterParamsGeneric
